import { inject } from 'vue';

import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';

export default () => {
  const arcaneApiGateway = inject('arcaneApiGateway');

  const getUserData = async (userId) => {
    try {
      const { data } = await arcaneApiGateway.get(apiGatewayEndpoints.user.userData(userId));
      return data;
    } catch (error) {
      console.log('Failed to load a specific user data', error);
    }
  };

  return {
    getUserData,
  };
};
